import { useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { resetPassword } from "../../api/auth.api";

export default function ResetPassword() {
  const { uidb64, token } = useParams();
  const navigate = useNavigate();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [done, setDone] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    if (pw.length < 8) {
      setError("Password must be at least 8 characters");
      return;
    }
    if (pw !== pw2) {
      setError("Passwords don't match");
      return;
    }
    setLoading(true);
    try {
      await resetPassword(uidb64, token, pw);
      setDone(true);
      setTimeout(() => navigate("/login"), 2500);
    } catch (err) {
      setError(err?.response?.data?.detail || "Reset failed. The link may have expired.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-bg-main text-text-primary flex flex-col items-center justify-center px-6 py-10">
      <Link to="/" className="font-bold text-xl tracking-tight mb-8">
        Zen<span className="text-button-primary">cricket</span>data
      </Link>

      <div className="w-full max-w-md bg-bg-primary border border-border-default rounded-2xl p-8 sm:p-10">
        <div className="text-center mb-6">
          <h1 className="text-2xl font-extrabold tracking-tight">Set a new password</h1>
          <p className="text-text-secondary text-sm mt-1">
            Choose something only you'd guess.
          </p>
        </div>

        {done ? (
          <div className="bg-emerald-500/10 border border-emerald-500/30 rounded-lg p-4 text-sm text-text-primary text-center">
            <p className="font-medium mb-1">Password updated</p>
            <p className="text-text-secondary">Redirecting to sign-in…</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <label className="block mb-4">
              <span className="block text-[10px] uppercase tracking-wider text-text-secondary mb-1.5">
                New password
              </span>
              <input
                type="password"
                className="w-full bg-bg-secondary border border-border-default rounded-lg py-2.5 px-3.5 text-sm text-text-primary placeholder-text-secondary/60 focus:outline-none focus:border-button-primary transition-colors"
                placeholder="At least 8 characters"
                value={pw}
                onChange={(e) => setPw(e.target.value)}
                autoFocus
              />
            </label>

            <label className="block mb-2">
              <span className="block text-[10px] uppercase tracking-wider text-text-secondary mb-1.5">
                Confirm new password
              </span>
              <input
                type="password"
                className="w-full bg-bg-secondary border border-border-default rounded-lg py-2.5 px-3.5 text-sm text-text-primary placeholder-text-secondary/60 focus:outline-none focus:border-button-primary transition-colors"
                placeholder="Type it again"
                value={pw2}
                onChange={(e) => setPw2(e.target.value)}
              />
            </label>

            {error && (
              <div className="bg-button-primary/10 border border-button-primary/30 rounded-lg px-3.5 py-2.5 text-sm text-button-primary mt-3">
                {error}
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              className="mt-6 w-full bg-button-primary hover:brightness-110 disabled:opacity-50 text-white font-semibold py-3 rounded-lg transition-all"
            >
              {loading ? "Updating…" : "Update password"}
            </button>

            <p className="text-center text-xs text-text-secondary mt-4">
              Link expired or invalid?{" "}
              <Link to="/forgot-password" className="text-button-primary hover:brightness-110">
                Request a new one
              </Link>
            </p>
          </form>
        )}
      </div>
    </div>
  );
}
